import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder} from '@angular/forms';


@Component({
  selector: 'app-delivery-report',
  templateUrl: './delivery-report.component.html',
  styleUrls: ['./delivery-report.component.css']
})
export class DeliveryReportComponent implements OnInit {

  deliveryReportForm: FormGroup = this.fb.group({

    fechaDD: [''],
    fechaHD:[''], 
    cadete: [''],
    estado: [''],
   })

   displayedColumns: string[] = ['nombre','idP','fechaP','dirP','total','neto','envio','estado', 'comision','liquidacion'];
   dataSource = deliveryR;

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
  }

}
export interface DReport {
  nombre: string;
  idP: string;
  fechaP: any;
  dirP: string;
  total: any;
  envio: any;
  estado: string;
  comision: any;
  liquidacion: string;

}
const deliveryR : DReport[] = [
  {nombre: '',idP:'',fechaP:'',dirP:'',total:'',envio:'',estado:'', comision:'',liquidacion:'' },
  
];